import React, {useState} from 'react'
import QueryString from "qs";
import Axios from "axios";
import ChatBoxBtn from './ChatBoxBtn';
import botConfig from '../../config/config';
import config from 'config'


const WebsiteBot = () => {
    const [loader, setIsLoader] = useState(false)
    const [message, setMessage] = useState()

    const fetchTokenAndSave = async () => {

        const addTokenIntoCache = (cacheName, url, response) => {
            const data = new Response(JSON.stringify(response));
            if ('caches' in window) {
                caches.open(cacheName).then((cache) => {
                    cache.put(url, data);
                });
            }
        };
        const payload = QueryString.stringify({
            'password': `${botConfig.password}`
        });
        const requestConfig = {
            method: 'post',
            url: `${config.BOT_URL}jwthit`,
            headers: {
                'Accept': "application/json",
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: payload
        };
        try {

            const response = await Axios(requestConfig);
            const {data} = response;
            addTokenIntoCache("token", `${botConfig.cacheURL}`, data);
            const messagePayload = QueryString.stringify({
                'MSG': "hi",
                'mobile': '',
                'user_id': '',
            });
            const requestMessageConfig = {
                method: 'post',
                url: `${config.BOT_URL}send-msg/`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': data,
                },
                data: messagePayload
            };
            setIsLoader(true)
            const responseMessage = await Axios(requestMessageConfig);
            setIsLoader(false)
            const messageData = responseMessage.data;
            setMessage(messageData)

        } catch (err) {
            console.log(err);
        }
    }

    return (
        <div>
            <ChatBoxBtn
                firstMessage={message}
                fetchTokenAndSave={fetchTokenAndSave}
                loader={loader}
            />
        </div>
    )
}

export default WebsiteBot



// WEBPACK FOOTER //
// ./src/components/website-bot/WebsiteBot.js